import './login.css';
import {useContext, useState} from "react";
import LoginService from "../../services/login.service";
import {useNavigate} from "react-router-dom";
import Loaders from "../../shared/loaders/loaders";
import AppContext from "../../contexts/appContext/app.context";

const Login = () => {
    const appCtx = useContext(AppContext);
    const [showLoader, setShowLoader] = useState(false);
    const [credentials, setCredentials] = useState({
        userName: "sku005@test.intel.com",
        password: "Admin@123456789"
    })
    const [showFormError, setShowFormError] = useState(false);
    const [errors, setErrors] = useState([]);
    const navigate = useNavigate();

    const handleFormValChange = (e) => {
        setShowFormError(false);
        setCredentials((prevState) => {
            return {
                ...prevState,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleLogin = async () => {
        setShowLoader(true);
        setShowFormError(false);
        const response = await LoginService.doLogin(credentials);
        if (response?.message) {
            setShowFormError(true);
            setErrors(response.message);
        } else {
            appCtx.setLoggedIn(true);
            await LoginService.getUserDetails();
            navigate('dashboard');
        }
        setShowLoader(false);
    }

    return (
        <div className={'login-box  page-fade-in round-corner-8'}>
            <div className="font-22 text-align-center margin-b-30">Login</div>

            <ul className="form">
                <li>
                    <input name={'userName'}
                           type="text"
                           placeholder={'Username'}
                           value={credentials.userName}
                           onChange={handleFormValChange}/>
                </li>
                <li>
                    <input name={'password'}
                           type="password"
                           placeholder={'Password'}
                           value={credentials.password}
                           onChange={handleFormValChange}/>
                </li>
                <li>
                    <div className="btn width-block-100 sf-medium margin-b-10" onClick={handleLogin}>
                        Login
                        {showLoader &&
                            <div className="btn-loader loader-size-30"><Loaders/></div>
                        }
                    </div>
                    {showFormError &&
                        errors.map((error, index) =>
                            <div key={index} className="error sf-medium">{error.message}</div>
                        )
                    }
                </li>
            </ul>
        </div>
    )
}
export default Login;
